import Repository from '../../../Repository';
import { computed } from 'vue';
import store from '@/store';
import { useToast } from 'vue-toastification';

const company = computed(() => store.getters['company/info']);
const toast = useToast();

export default {
	index(params) {
		return Repository.get(`/company/${company.value.id}/admin/user`, { params: params });
	},
	list(params) {
		return Repository.get(`/company/${company.value.id}/admin/user/list`, { params: params });
	},
	invite(payload) {
		return Repository.post(`/company/${company.value.id}/admin/user/invite`, payload);
	},
	show(id) {
		return Repository.get(`/company/${company.value.id}/admin/user/${id}`);
	},
	update(id, payload) {
		return Repository.put(`/company/${company.value.id}/admin/user/${id}`, payload).then((response) => {
			toast.success(`Usuario actualizado correctamente.`);
			return response;
		});
	},
	destroy(id) {
		return Repository.delete(`/company/${company.value.id}/admin/user/${id}`).then((response) => {
			toast.success(`Usuario eliminado correctamente.`);
			return response;
		});
	}
}